var _pattern, _path, _linearGradient, _path2, _path3, _linearGradient2, _path4, _path5, _linearGradient3, _path6, _path7, _linearGradient4, _path8, _path9, _defs, _clipPath, _path10, _g, _path11, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIphone12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "iphonePortrait",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 435.5 877.1"
  }, props), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    y: 877.1,
    width: 363,
    height: 730,
    patternUnits: "userSpaceOnUse",
    id: "iphone_12_svg__g",
    viewBox: "0 -730 363 730",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-730h363V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-730h363V0H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424.3 225.6h10.2c.6 0 1 .4 1 1V328c0 .6-.4 1-1 1h-10.2c-.6 0-1-.4-1-1V226.6c0-.6.5-1 1-1z",
    fill: "#12284a"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iphone_12_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 300.485,
    y1: 2317.29,
    x2: 300.485,
    y2: 2344.065,
    gradientTransform: "matrix(3.78 0 0 3.78 -706.44 -8532.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455d80"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424.3 226.8h10.2c.6 0 1 .4 1 1V327c0 .6-.4 1-1 1h-10.2c-.6 0-1-.4-1-1v-99.2c0-.5.5-1 1-1z",
    fill: "url(#iphone_12_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 203.3h10.2c.6 0 1 .4 1 1v62.6c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1v-62.6c0-.6.4-1 1-1z",
    fill: "#12284a"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iphone_12_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 281.622,
    y1: 2316.3,
    x2: 281.622,
    y2: 2332.821,
    gradientTransform: "matrix(3.78 0 0 3.78 -1058.45 -8550.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455d80"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 204.6h10.2c.6 0 1 .4 1 1V266c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1v-60.5c0-.5.5-.9 1-.9z",
    fill: "url(#iphone_12_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 287.5h10.2c.6 0 1 .4 1 1v62.6c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1v-62.6c0-.5.5-1 1-1z",
    fill: "#12284a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iphone_12_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 281.622,
    y1: 2320.05,
    x2: 281.622,
    y2: 2336.571,
    gradientTransform: "matrix(3.78 0 0 3.78 -1058.45 -8480.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455d80"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 288.8h10.2c.6 0 1 .4 1 1v60.4c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1v-60.5c0-.5.4-.9 1-.9z",
    fill: "url(#iphone_12_svg__c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 139.4h10.2c.5 0 1 .4 1 1V172c0 .5-.4 1-1 1H1c-.5 0-1-.4-1-1v-31.6c0-.6.4-1 1-1z",
    fill: "#12284a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "iphone_12_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 281.619,
    y1: 2313.45,
    x2: 281.619,
    y2: 2321.754,
    gradientTransform: "matrix(3.78 0 0 3.78 -1058.45 -8603.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#19365e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455d80"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 140.6h10.2c.5 0 1 .4 1 1V171c0 .5-.4 1-1 1H1c-.5 0-1-.4-1-1v-29.4c0-.5.4-1 1-1z",
    fill: "url(#iphone_12_svg__d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M364.7.6H70.8c-37 0-66.9 30-66.9 66.9v742c0 37 30 66.9 66.9 66.9h293.8c37 0 66.9-30 66.9-66.9v-742C431.6 30.6 401.6.6 364.7.6zM411 811.2c0 25.3-20.5 45.8-45.8 45.8H70.3c-25.3 0-45.8-20.5-45.8-45.8V65.8C24.5 40.5 45 20 70.3 20h35c5.4 0 8.1.5 8.1 9s5.3 22.8 24.1 22.8H298c18.8 0 24.1-14.4 24.1-22.8s2.8-9 8.1-9h35c25.3 0 45.8 20.5 45.8 45.8v745.4z",
    fill: "#969696"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "iphone_12_svg__e",
    d: "M70.4-.8h293.8c37 0 66.9 30 66.9 66.9v742c0 37-30 66.9-66.9 66.9H70.4c-37 0-66.9-30-66.9-66.9v-742C3.4 29.2 33.4-.8 70.4-.8z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "iphone_12_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iphone_12_svg__e",
    overflow: "visible"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M364.6 1.6H70.3C34.8 1.5 5.9 30.2 5.8 65.7v742.5c-.1 35.6 28.6 64.5 64.2 64.6h294.2c35.5.1 64.4-28.6 64.6-64.2V66.1c.1-35.5-28.7-64.4-64.2-64.5zM411 811.2c0 25.3-20.5 45.8-45.8 45.8H70.3c-25.3 0-45.8-20.5-45.8-45.8V65.8C24.5 40.5 45 20 70.3 20h35c5.4 0 8.1.5 8.1 9s5.3 22.8 24.1 22.8H298c18.8 0 24.1-14.4 24.1-22.8s2.8-9 8.1-9h35c25.3 0 45.8 20.5 45.8 45.8v745.4z",
    clipPath: "url(#iphone_12_svg__f)",
    fill: "#142b4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#445b75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.7 0h9.8v14.4h-9.8zM3.3 781.4h21.2v9.8H3.3zM3.3 87.4h21.2v9.8H3.3zM411 87.4h21.2v9.8H411zM411 781.4h21.2v9.8H411zM90 864.7h9.8v12.4H90z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M363.5 6.1H71.9c-34.8 0-63 28.3-63 63.1v738.7C8.9 842.7 37.1 871 72 871h291.6c34.8 0 63.1-28.2 63.1-63.1V69.2c-.1-34.8-28.3-63.1-63.2-63.1zM411 811.2c0 25.3-20.5 45.8-45.8 45.8H70.3c-25.3 0-45.8-20.5-45.8-45.8V65.8C24.5 40.5 45 20 70.3 20h35c5.4 0 8.1.5 8.1 9s5.3 22.8 24.1 22.8H298c18.8 0 24.1-14.4 24.1-22.8s2.8-9 8.1-9h35c25.3 0 45.8 20.5 45.8 45.8v745.4z",
    stroke: "#434343",
    strokeWidth: 0.5,
    strokeMiterlimit: 15.12
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 260.6,
    cy: 31.6,
    r: 7.9,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.6,
    cy: 31.6,
    r: 4.9,
    fill: "#0a0d13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.6,
    cy: 31.6,
    r: 3.7,
    fill: "#091427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1 29.1c-.5 0-1.1.7-1.1 2s.5 2.1.9 2.1 1.6-2 .2-4.1zM261.2 28.6c-.7.2-.8 1.3-.8 2s.9 2.3 2 2c1-.5 1.4-1.6.9-2.6 0-.1-.1-.1-.1-.2-.3-.9-1.2-1.6-2-1.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#235a91",
    fillOpacity: 0.56
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("pattern", {
    id: "iphone_12_svg__h",
    xlinkHref: "#iphone_12_svg__g",
    patternTransform: "matrix(1.5 0 0 1.5 3915.69 6086.525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.9 27.1h38.3c2.3 0 4.1 1.8 4.1 4.1 0 2.2-1.9 4-4.1 4h-38.3c-2.2 0-4-1.8-4.1-4 0-2.2 1.8-4.1 4.1-4.1z",
    fill: "url(#iphone_12_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.9 27.1c-2.3-.1-4.2 1.6-4.3 3.9s1.6 4.2 3.9 4.3H238.2c2.3.1 4.2-1.6 4.3-3.9.1-2.3-1.6-4.2-3.9-4.3H199.9z",
    fill: "none",
    stroke: "#292929",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeMiterlimit: 14.91
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.4 31.2c0 .7-.4 1.3-.9 1.3s-.9-.6-.9-1.3.4-1.3.9-1.3.9.6.9 1.3zM242.3 31.2c0 .7-.4 1.3-.9 1.3s-.9-.6-.9-1.3c0-.7.4-1.3.9-1.3s.9.6.9 1.3z"
  })))));
}
export default SvgIphone12;